export function TargetProject({name, image, desc, demo, techs = [], github, linkDemo, period, category}){
  return(
    <article className="target-project" title={name}>
      {image
        ? <img src={image} alt="Imagen del proyecto" title={name} className="project-image" />
        : (
          <div className="project-image project-image-placeholder" role="img" aria-label={`Proyecto ${name}`}>
            <span className="placeholder-period">{period}</span>
            <span className="placeholder-category">{category}</span>
          </div>
        )
      }

      <div className="project-description">
        <h4 className="subtitle" title={name}>
          {github ? <a href={github} title={name} target="_blank" rel="noopener noreferrer">{name}</a> : name}
        </h4>
        {image && period && <p className="project-period">{period}</p>}
        <p className="text">{desc}</p>
      </div>

      <div className="project-btns">
        {(demo || github)
          ? <>
              {demo ? <a href={linkDemo} title="Probar proyecto" target="_blank" rel="noopener noreferrer" className="demo-btn-true">Probar</a> : <a href="none" title="Probar proyecto" className="demo-btn-false">Probar</a>}
              <a href={github} title="Ver código" target="_blank" rel="noopener noreferrer" className="code-btn">Ver código</a>
            </>
          : <p className="project-institutional">Sistema institucional</p>
        }
      </div>

      {techs.length > 0 && (
        <div className="project-technologies">
          {techs.map((tech) => (
            <img key={tech} src={tech} alt="#" />
          ))}
        </div>
      )}
    </article>
  );
}
